import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./i18n"; // Initialize i18n before App
import App from "./App";

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Appliquer RTL/LTR synchroniquement avant le rendu React (évite sidebar à gauche en arabe)
const storedLang = localStorage.getItem('i18nextLng')?.split('-')[0];
if (storedLang) {
  document.documentElement.dir = storedLang === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = storedLang;
}

// react-snap prerenders static HTML into #root at build time; hydrate it when present.
const rootElement = document.getElementById("root");
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
